const selfConfig = {
  logoUrl: '',
  barLogoUrl: '',
  faviconUrl: './favicon.ico',
  // 选择租户页面
  tenantDashboard: {
    logo: ''
  }
}

const mjnConfig = {
  logoUrl: require('@/assets/mjn/logo.png'),
  barLogoUrl: '',
  faviconUrl: './logo.png',
  // 选择租户页面
  tenantDashboard: {
    logo: require('@/assets/mjn/logo.png')
  }
}

const isMjn = !!(['tracking-gs.qa.1dreams.com', 'ts.mjn.dataxcrm.com'].includes(location.host))

const projectConfig = isMjn ? mjnConfig : selfConfig

export { projectConfig, isMjn }
